<template>
  <loader v-if="loading"/>
  <mortgage-content-page v-else />
</template>

<script>
import BaseUI from '@riseupil/base-ui';
import Loader from '@/base-components/Loader';
import MortgageContentPage from './MortgageContentPage.vue';

export default {
  name: 'MortgageResultsPage',
  components: {
    MortgageContentPage,
    Loader,
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ctaProps() {
      return {
        backgroundColor: BaseUI.Colors.riseupWhite,
      };
    },
  },
  async created() {
    this.loading = false;
  },
};
</script>

<style scoped lang="scss">
@import "~@riseupil/base-ui/src/scss/riseup-colors";
@import "~@riseupil/base-ui/src/scss/spacings";

.cards-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
